
      import Download from './download.vue'
      import type { App, Plugin } from 'vue'

      export const DownloadPlugin: Plugin = {
        install(app: App) {
          app.component('Download', Download)
        },
      }
      export { Download }
      